// import { soundManager } from "../../sound_manager";
// import PlaySound from "./play_sound";
import { mouseEvent } from "../common/mouse_event";
import SentenceGroup from "./sentence_group";
import BookItem from "../common/bookItem";
export default class ReadSentenceShort extends BookItem {
    targetGroup = null;
    turns = []; //紀錄要播的順序
    sentences = []; //紀錄要播的段落實體
    nextPlayTimeout = null;
    constructor(el, target) {
        super(el, target);
        this.targetGroupName = el.targetGroup;
        this.needStopBtn = el.needStopBtn;
        this.targetTurn = el.targetTurn;

        this.audio = window.soundManager.soundPlayer;
        this.isTrigger = false;
        //測試用
    }

    init() {
        this.add_mouse_event();


        //解析輸入的順序，轉換成陣列
        this.targetTurn = this.targetTurn.replace(/\[*\]*/g, '');

        let temp_turns = this.targetTurn.split(',');
        this.turns = [];
        for (let i = 0; i < temp_turns.length; i++) {
            this.turns.push(temp_turns[i]);
        }

        //尋找頁面上所有段落群組並與目標名稱對照，紀錄目標群組
        for (let i = 0; i < this.itemControl.bookItems.length; i++) {
            if (this.itemControl.bookItems[i] instanceof SentenceGroup && this.itemControl.bookItems[i].target.name == this.targetGroupName) {
                this.targetGroup = this.itemControl.bookItems[i];
                break;
            }
        }


    }

    trigger() {
        console.log('do something(read sentence short)');

        //尋找頁面上所有短句(除了自己)並停止trigger
        for (let i = 0; i < this.itemControl.bookItems.length; i++) {
            if (this.itemControl.bookItems[i] instanceof ReadSentenceShort && this.itemControl.bookItems[i] != this) {
                this.itemControl.bookItems[i].stopTrigger();
            }
        }

        if (this.sentences.length == 0) {
            //從群組內取得段落並與順序對照，找出後依照順序放置於陣列
            this.targetGroup.sentences.forEach(element => {
                if (this.turns.includes(element.turn)) this.sentences.push(element);
            });
        }

        let self = this;
        let count = 0;

        let playTrigger = function () {
            self.audio.removeEventListener("ended", playTrigger);

            //因播放其他音檔等原因提早結束觸發(因播放其他音檔應不會觸發end事件，此函式應不會觸發)
            if (!self.isTrigger) {
                console.log("read short early end");
                self.target.gotoAndStop(0);
                return;
            }

            //正常結束觸發
            if (!self.sentences[count]) {
                self.target.gotoAndStop(0);
                self.isTrigger = false;
                return;
            }

            if (count == 0) {
                self.sentences[count].trigger(false);
                self.sentences[count].target.gotoAndStop(0);
                self.audio.addEventListener("ended", playTrigger);
            } else {
                //第二句開始須延遲0.5秒後播放，且因count會先+1所以須-1
                self.nextPlayTimeout = setTimeout(function () {
                    self.sentences[count - 1].trigger(false);
                    self.sentences[count - 1].target.gotoAndStop(0);
                    self.audio.addEventListener("ended", playTrigger);
                }, 500);
            }

            count += 1;
        }

        if (!this.isTrigger) {
            this.isTrigger = true;
            playTrigger();
        } else {
            if (this.needStopBtn) {
                this.isTrigger = false;
                window.soundManager.audioPlayerStop();
            }
        }
    }

    stopTrigger() {
        this.target.gotoAndStop(0);
        this.isTrigger = false;
        if (this.nextPlayTimeout) {
            clearTimeout(this.nextPlayTimeout);
            this.nextPlayTimeout = null;
        }
    }

    add_mouse_event() {
        this.target.mouseChildren = false;
        this.target.removeAllEventListeners();
        this.target.addEventListener("click", () => {
            this.trigger();
            let frame = this.isTrigger ? 1 : 0;
            this.target.gotoAndStop(frame);
        });
    }
}